import { useRouter } from 'next/router';
import React from 'react';
import { connect } from 'react-redux';
import { omit } from 'lodash';
import { TRACK_EVENT_NAMES } from 'Tracking/constants';
import { TrackingPageLoad } from 'Tracking/tracking-pageload/TrackingPageLoad';
import { mapStateToProps as mapStateToPropsBookingEngineForm } from 'Components/widgets/booking-engine-form/BookingEngineForm.container';
import { TrackRouterPage } from 'Tracking/track-page/TrackRouterPage';
import { resolveDepartureDateTracking } from './utils';
type BookingCriteria = {
  initialDuration: number;
  initialNumberOfAdults: number;
  initialNumberOfChildren: number;
};
type GQLProps = {
  resort: Product;
  price: {
    bestPrice: {
      value: number;
    };
    initialPrice: {
      value: number;
    };
    termsAndConditions: {
      departureCity: {
        name: string;
        value: string;
      };
      departureDate: number;
    };
  };
  bookingCriteria: BookingCriteria;
};
type TrackingProps = {
  trackingData: Record<string, TrackAttribute | null | undefined>;
};
type Props = TrackingProps & GQLProps;

function DynamicPageLoadTracking({ trackingData }: TrackingProps) {
  if (trackingData.resort_type === 'TOUR') {
    return (
      <TrackRouterPage pageName={String(trackingData.pageName ?? '')} payload={trackingData} />
    );
  } else {
    return <TrackingPageLoad {...trackingData} />;
  }
}

function mapStateToProps(state, props) {
  const { queryParams, trackingData = {}, resort = {} } = props;
  const { isProductPage = false } = trackingData;

  if (!isProductPage) {
    return {
      trackingData,
    };
  }

  if (queryParams.departureDate) {
    return {
      trackingData: {
        ...omit(trackingData, ['isProductPage']),
        ...resolveDepartureDateTracking(queryParams.departureDate),
        page_name: TRACK_EVENT_NAMES.CLICK_SHOPPING_TOUR_CONFIRMATION,
        resort_adult: Number(queryParams.adults),
        resort_children: Number(queryParams.children),
        resort_participants: Number(queryParams.adults) + Number(queryParams.children),
      },
    };
  }

  const { adultsNumber, kids, duration } = mapStateToPropsBookingEngineForm(state, {
    ...trackingData,
    queryParams,
    resort,
  });
  const kidsNumber = kids.length;
  delete trackingData.bookingCriteria;
  return {
    trackingData: {
      ...(trackingData.resort_type !== 'TOUR'
        ? {
            ...trackingData,
            resortAdult: adultsNumber,
            resortChildren: kidsNumber,
            resortNightNumber: duration,
            resortTotalParticipant: adultsNumber + kidsNumber,
          }
        : { ...omit(trackingData, ['isProductPage']) }),
    },
  };
}

const ConnectedDynamicPageLoadTracking = connect(mapStateToProps)(DynamicPageLoadTracking);

const PageTrackingLine = (props: Props) => {
  const { query: queryParams } = useRouter();
  return <ConnectedDynamicPageLoadTracking {...props} queryParams={queryParams} />;
};

export default PageTrackingLine;
